/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRecord.defs'
export { main as default } from './getRecord.defs'
